import React from 'react';

import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider} from "firebase/auth";

import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import LoginPage from './components/login/login';
import ClientPage from './components/client/client';
import { Navigate } from "react-router-dom";

import 'firebase/firestore';
import ProtectedRoute from './components/security/ProtectedRoute';



import Menu from "./components/menu/menu";


// Configurazione Firebase
const firebaseConfig  = {
  apiKey: "AIzaSyBGsPcSlqyRd0plvdB4KvRUbQtdK8A3yxs",
  projectId: "gestionematteo",
  storageBucket: "gestionematteo.appspot.com",
  appId: "1:585715271898:android:591c0337108b60e279bde3"
};

// Inizializza Firebase
const firebaseApp = initializeApp(firebaseConfig);
const auth = getAuth(firebaseApp);
const provider = new GoogleAuthProvider();

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<LoginPage auth={auth} />} /> 
      <Route path="/" element={<LoginPage  auth={auth} />} />  
        <Route path="/client" 
              element={
                <ProtectedRoute auth={auth}>
                        <ClientPage auth={auth} />
                </ProtectedRoute>              
              } />


           {/*Rotta pubblica */}
          <Route path="/menu/ilmiomenu" element={<Menu isProtected={false}  />} />  

           {/* Root redirige sempre alla rotta pubblica  
          <Route path="/" element={<Navigate to="/menu/ilmiomenu" replace isProtected={false} />} />*/}

          {/* Qualsiasi altra rotta non definita redirige a /menu/ilmiomenu */}
          <Route path="*" element={<Navigate to="/menu/ilmiomenu" replace isProtected={false} />} />


      </Routes>
    </Router>
  );
}

export default App;
